import { CommonHelperFunctions } from "@kuika/kuika-cl-model";
import Axios, { AxiosResponse } from "axios";
import { KMainFunctions } from "../shared/utility/main-functions";

const backendUrl = CommonHelperFunctions.GetBackendUrl();

export class DynamicTypeService {
  public static async GetDynamicTypes(): Promise<AxiosResponse> {
    try {
      return await Axios.get(`${backendUrl}/dynamictype/getdynamictypes`);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async GetDynamicTypesForScreen(screenJson: string): Promise<AxiosResponse> {
    try {
      return await Axios.post(`${backendUrl}/dynamictype/getdynamictypesforscreen`, { screenJson });
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }
}
